import styled from 'styled-components';
import Color from 'color';
import { Image as NextImage } from '@starsoft/common/components';
import { getComputedColor } from '@/utils/theme';

export const Container = styled.div`
  width: 95vw;
  max-width: 400px;
  height: fit-content;
  background-color: ${({ theme }) => theme.vars.palette.background.paper};
  border-radius: ${({ theme }) => theme.vars.shape.borderRadius};
  display: flex;
  flex-direction: column;
  padding: 24px 0px;

  @media (max-width: 768px) {
    padding: 16px 0px;
  }
`;

export const TextContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  z-index: 7;
`;

export const TitleLogin = styled.div`
  font-size: 38px;
  color: ${({ theme }) => theme.vars.palette.text.primary};
  font-weight: 500;
  line-height: 1.2;
  max-width: 70%;
`;

export const DescriptionLogin = styled.div`
  font-size: 18px;
  color: ${({ theme }) =>
    Color(getComputedColor(theme.vars.palette.text.primary))
      .alpha(0.8)
      .toString()};
  line-height: 1.1rem;
  max-width: 70%;
  font-weight: 300;
`;

export const Image = styled(NextImage)`
  height: 100%;
  object-fit: fill;
  opacity: 0.7;
  object-position: center;
`;

export const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
`;

export const Spacer = styled.div`
  height: 20px;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-track {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    display: none;
  }

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

export const DesktopOnly = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpacerCurrency = styled.div`
  margin-left: 5px;
`;

export const Currency = styled(NextImage)`
  width: 20px;
  height: 20px;
  margin-right: 5px;
`;

export const AmountLabel = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.vars.palette.text.primary};
  padding-top: 2px;
`;

export const SubHeader = styled.div`
  font-size: 24px;
  margin-bottom: 10px;
  font-weight: 500;
  width: 100%;
  text-align: left;
`;
